<template>
  <section>
    <!-- Componentes externos -->
    <ReprogramarCronograma />
    <SolicitarEjecucionVacacion />
    <VerDetalle />
    <VerDetalleUsoVacacion />
    <AprobarUsoJefeInmediato />
    <AprobarReprogramacionVacacion />
    <Reprogramar />
    <SolicitarEjecucionVacacion />
    <VerReporte />
    <VerReprogramaciones />
    <RechazarReprogramacionJefe />
    <!-- Componentes externos PAPELETAS CON CARGO A VACACION-->
    <VerPermiso />
    <AprobarPermiso />
    <RechazarPermiso />
    <h3 class="primary--text">
      <v-icon color="primary">done</v-icon> Aprobación/Rechazo de vacaciones (Jefe)
    </h3>
    <!-- Seleccionar gestion-->
    <v-flex xs12 md6>
      <v-autocomplete
        :items="lista_gestiones"
        item-text="periodo"
        item-value="periodo"
        label="Seleccione la gestión"
        v-model="periodo_seleccionado"
        @change="actualizaCrudTable()"
        required
        outline
        success
        clearable
      ></v-autocomplete>
    </v-flex>
    <v-card>
      <v-card-text>
        <p>
          <strong>Dependencia: </strong
          >{{ this.$storage.get("user").unidad[0].nombre_unidad }}
        </p>
        <v-layout align-center justify-start row wrap>
          <v-flex shrink>
            <!-- Boton filtro -->
            <v-tooltip bottom>
              <v-btn
                @click.native="
                  () => {
                    filterShow = filterShow ? false : true;
                  }
                "
                class="btn-refresh"
                slot="activator"
                ><v-icon>filter_list</v-icon>
              </v-btn>
              <span>Búsqueda/filtros</span>
            </v-tooltip>
          </v-flex>
          <v-flex d-flex shrink>
            <!-- Boton acutualizar -->
            <v-tooltip bottom>
              <v-btn
                @click.native="
                  cargarVacacionesProgramadas(periodo_seleccionado)
                "
                class="btn-refresh"
                slot="activator"
                ><v-icon>refresh</v-icon>
              </v-btn>
              <span>{{ $t("common.updateList") }}</span>
            </v-tooltip>
          </v-flex>
          <v-flex d-flex shrink>
            <!-- Boton Calendario -->
            <CalendarioVacaciones />
          </v-flex>
        </v-layout>

        <!-- Filtros-->
        <v-flex xs12>
          <transition name="slide-fade">
            <div class="filter-container-rrhh" v-show="filterShow">
              <v-icon small color="primary">search</v-icon>
              <div class="filter-item">
                <v-text-field
                  label="Nro"
                  type="number"
                  v-model="form.numero"
                  @input="filterNumero"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Nombres"
                  type="text"
                  v-model="form.nombres"
                  @input="filterNombres"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Fecha salida"
                  type="text"
                  v-model="form.fecha_desde"
                  @input="filterFechaDesde"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Fecha fin"
                  type="text"
                  v-model="form.fecha_hasta"
                  @input="filterFechaHasta"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Días programados"
                  type="number"
                  v-model="form.dias"
                  @input="filterDias"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Tipo"
                  type="text"
                  v-model="form.tipo"
                  @input="filterTipo"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Estado"
                  v-model="form.estado"
                  @input="filterEstado"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Fecha solicitud"
                  v-model="form.fecha_solicitud"
                  @input="filterFechaSolicitud"
                ></v-text-field>
              </div>
              <!-- botones cerrar -->
              <div class="btn-filter">
                <v-tooltip bottom>
                  <v-btn icon small slot="activator" @click.native="recargar()">
                    <v-icon small>refresh</v-icon>
                  </v-btn>
                  <span>Recargar filtros</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn
                    icon
                    slot="activator"
                    @click.native="
                      () => {
                        filterShow = false;
                      }
                    "
                  >
                    <v-icon small>close</v-icon>
                  </v-btn>
                  <span>Cerrar filtros</span>
                </v-tooltip>
              </div>
            </div>
          </transition>
        </v-flex>

        <v-data-table
          v-if="sw_crud_table"
          class="elevation-1 tabla-comprimida-light"
          :items="lista_vacaciones"
          :headers="headers"
          :disable-initial-sort="true"
          item-key="id"
          :loading="loading"
          no-data-text="No se tiene registros"
          no-results-text="No se encontraron coincidencias"
          :search="filters"
          :custom-filter="customFilter"
        >
          <!-- Template injectable de la cabecera de la tabla-->

          <template slot="buttons">
            <v-tooltip bottom>
              <v-btn
                color="warning"
                dark
                @click.native.stop="verReporte({}, 7)"
                slot="activator"
                ><v-icon dark>picture_as_pdf</v-icon>
              </v-btn>
              <span>Ver reporte</span>
            </v-tooltip>
          </template>
          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <!-- Agregar las columnas que consideré necesarias -->

            <td
              class="text-xs-center"
              :id="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              {{ items.item.numero }}
            </td>

            <td
              class="text-xs-center"
              :id="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              {{ items.item.nombres }}
            </td>
            <td
              class="text-xs-center"
              :id="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              {{ items.item.fecha_desde }}
            </td>
            <td
              class="text-xs-center"
              :id="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              {{ items.item.fecha_hasta }}
            </td>
            <td
              class="text-xs-center"
              :id="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              {{ items.item.dias }}
            </td>
            <td
              class="text-xs-center"
              :id="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              {{ items.item.tipo }}
            </td>
            <td
              class="text-xs-center"
              :id="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              {{
                items.item.estado && items.item.id_estado == 7
                  ? "Aprobada Inmediato Superior"
                  : items.item.estado
                  ? items.item.estado
                  : ""
              }}
            </td>
            <td
              class="text-xs-center"
              :id="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              {{
                items.item.jefe &&
                  (items.item.id_estado == 55 ||
                    items.item.id_estado == 58 ||
                    items.item.id_estado == 68 ||
                    items.item.id_estado == 69)
              }}
            </td>
            <td
              class="text-xs-center"
              :id="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              {{ items.item.fecha_solicitud }}
            </td>
            <td
              class="text-xs-center"
              :id="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              {{ items.item.justificacion_rechazo }}
            </td>
            <!-- -------------------------------------------- VACACIONES REPROGRAMADAS Y PROGRAMADAS BOTONES ---------------------------------------------->
            <td
              v-if="
                items.item.tipo == 'P' ||
                  items.item.tipo == 'R' ||
                  items.item.tipo == 'FR'
              "
              :id="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              <!-- ver detalle -->
              <v-btn
                color="#3dca24"
                @click.prevent="verDetalle(items.item)"
                icon
                title="Ver detalle"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
              <!-- VACACIONES REPROGRAMADAS-->
              <!-- <v-btn
                v-if="items.item.id_estado == 57"
                color="#44deaa"
                @click.prevent="verReprogramaciones(items.item)"
                icon
                title="Ver detalle de reprogramaciones"
              >
                <v-icon>today</v-icon>
              </v-btn> -->
              <!--  aprobacion DE LA VACACION-->
              <v-btn
                v-if="
                  items.item.id_estado == '55' &&
                    items.item.id_jefe == items.item.id_jefe_ultimo &&
                    bandera_fecha_corte
                "
                color="#44deaa"
                @click.prevent="aprobarUsoJefeInmediato(items.item)"
                icon
                title="Aprobar uso de vacación"
              >
                <v-icon>send</v-icon>
              </v-btn>

              <!--  rechazar uso de VACACION-->
              <v-btn
                v-if="
                  items.item.id_estado == '55' &&
                    items.item.tipo == 'P' &&
                    !items.item.id_padre &&
                    bandera_fecha_corte
                "
                color="#FF5D34"
                @click.prevent="reprogramar(items.item)"
                icon
                title="Reprogramar"
              >
                <v-icon>close</v-icon>
              </v-btn>
              <!--  APROBAR REPROGRAMACION-->
              <v-btn
                v-if="items.item.id_estado_hijo == '68' && bandera_fecha_corte"
                color="#a87af3"
                @click.prevent="aprobarReprogramacion(items.item)"
                icon
                title="Aprobar reprogramación de vacación"
              >
                <v-icon>send</v-icon>
              </v-btn>
              <!-- Rechazar reprogramacion y editarla nuevamente-->
              <v-btn
                v-if="
                  items.item.id_estado_hijo &&
                    items.item.id_estado_hijo == 68 &&
                    bandera_fecha_corte
                "
                color="#FF5D34"
                @click.prevent="rechazarReprogramacion(items.item)"
                icon
                title="Rechazar reprogramación"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </td>
            <!-- ------------------------------------------------- BOTONES PAPELETAS CON CARGO A VACACION---------------------------------------------->
            <td
              v-if="items.item.tipo == 'VC'"
              :id="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              <v-btn
                color="info"
                @click.prevent="verPermiso(items.item)"
                icon
                title="Ver vacacion"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>

              <!-- btn de aprobacion-->
              <v-btn
                v-if="items.item.id_estado == 6 "
                color="success"
                @click.prevent="aprobarPermiso(items.item)"
                icon
                title="Aprobar permiso"
              >
                <v-icon>done</v-icon>
              </v-btn>
              <!-- <v-btn
                v-if="
                  (items.item.id_estado == 6 ||
                    items.item.id_estado == 21 ||
                    items.item.id_estado == 12 ||
                    items.item.id_estado == 7) &&
                  items.item.aprobar == 1
                "
                color="success"
                @click.prevent="aprobarPermiso(items.item)"
                icon
                title="Aprobar permiso"
              >
                <v-icon>done</v-icon>
              </v-btn> 
            ADICIONAR TAMBIEN AL BOTON DE RECHAZO && aprobar==1-->
              <!-- btn de rechazo papaeleta con cargo a vacacion-->

              <v-btn
                v-if="items.item.id_estado == 6 "
                color="#E61C5B"
                dark
                @click.prevent="rechazarPermiso(items.item)"
                icon
                title="Rechazar permiso"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>
<script>
import CrudTable from "@/common/util/crud-table-sin-orden/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import ReprogramarCronograma from "./dialogs/ReprogramarCronograma.vue";
import SolicitarEjecucionVacacion from "./dialogs/SolicitarEjecucionVacacion.vue";
import VerDetalle from "../vacacion_rrhh/dialogs/VerDetalle.vue";
import VerDetalleUsoVacacion from "../vacacion_rrhh/dialogs/VerDetalleUsoVacacion.vue";
import AprobarUsoJefeInmediato from "./dialogs/AprobarUsoJefeInmediato.vue";
import AprobarReprogramacionVacacion from "./dialogs/AprobarReprogramacionVacacion.vue";
import Reprogramar from "./dialogs/Reprogramar.vue";
import VerReporte from "./dialogs/VerReporte";
import VerReprogramaciones from "./dialogs/VerReprogramaciones";
import RechazarReprogramacionJefe from "./dialogs/RechazarReprogramacionJefe";
//Componentes externos PAPELETAS CON CARGO A VACACION-->
import VerPermiso from "../vacacion_rrhh/dialogs/VerPermiso.vue";
import AprobarPermiso from "./dialogs/AprobarPermiso";
import RechazarPermiso from "./dialogs/RechazarPermiso";
// Filtros
import FiltrosVacacion from "../vacacion_rrhh/mixins/FiltrosVacacion";
// CALENDARIO
import CalendarioVacaciones from "./components/CalendarioVacaciones.vue";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud, FiltrosVacacion],
  // Variables iniciales del componente
  data() {
    return {
      lista_vacaciones: [],
      loading: false,
      // Variables filtros
      filterShow: true,
      form: {},
      filters: {
        numero: "",
        fecha_desde: "",
        fecha_hasta: "",
        dias: "",
        tipo: "",
        estado: "",
        fecha_solicitud: "",
        nombre_unidad: "",
        nombres: "",
        bandera_fecha_corte: true
      },
      url: "vVacacionReprogramadaYParaUsoJerarquicos",
      user: this.$storage.get("user"),
      graphql: true,
      lista_gestiones: [],
      periodo_seleccionado: new Date().getFullYear(),
      sw_crud_table: true,
      // Cabecera de la tabla
      headers: [
        // { text: 'Nombre de la cabecera', value: 'Campo que deseamos interpolar', align: 'center' },
        { text: "Nro", sortable: false, value: "numero", align: "center" },

        { text: "Nombre", value: "", align: "center" },
        // { text: "Dependencia", value: "", align: "center" },
        { text: "Fecha desde", value: "fecha_desde", align: "center" },
        { text: "Fecha hasta", value: "fecha_hasta", align: "center" },
        { text: "Días programados", value: "dias", align: "center" },
        { text: "Tipo", value: "tipo", align: "center" },
        { text: "Estado", value: "estado", align: "center" },
        { text: "Solicitud enviada a:", value: "jefe", align: "center" },
        {
          text: "Fecha de solicitud",
          value: "fecha_solicitud",
          align: "center"
        },
        {
          text: "Justificación:",
          value: "justificacion_rechazo",
          align: "center"
        },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
     	id_jefe

      `

      // initData: [
      //   {
      //     state: true,
      //     param: "id_jefe",
      //     value: this.getIdPersona(),
      //   },
      //   {
      //     state: true,
      //     param: "lista_estados",
      //     value: '"55,56,57,58,65,70"',
      //   },],
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    await this.obtenerListaGestiones();
    await this.obtenerFechaCorte();

    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
    this.$bus.$on("closeDialogVerDetalleUsoFuncionario", async () => {});
    this.$bus.$on("closeDialogAprobarUsoJefeInmediato", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
    });
    this.$bus.$on("closeDialogReprogramarJefeInmediato", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
    });
    this.$bus.$on("closeDialogSolicitarUsoVacacionFuncionario", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
    });
    this.$bus.$on("closeDialogVerDetalleUsoFuncionarioRRHH", () => {});
    this.$bus.$on("closeDialogVerDetalleUsoFuncionarioNormalRRHH", () => {});
    this.$bus.$on("closeDialogVerPermisoRRHH", () => {});
    this.$bus.$on("closeDialogAprobarPapJefeI", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
    });
    this.$bus.$on("closeDialogRechazaPapeletaJefeI", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
    });
    this.$bus.$on("closeDialogRechazarReprogramacionJefe", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
    });
  },
  // Métodos y funciones del componente
  methods: {
    async actualizaCrudTable() {
      if (!this.periodo_seleccionado) {
        return;
      }
      this.sw_crud_table = false;
      await new Promise(resolve => setTimeout(resolve, 100));
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
      this.sw_crud_table = true;
    },
    //metodo para obtener las gestiones:
    async obtenerListaGestiones() {
      const user = this.$storage.get("user");
      try {
        this.lista_gestiones = [{ periodo: 2023 }, { periodo: 2024 },{ periodo: 2025 }, { periodo: 2026 }];
      } catch (error) {
        console.log(error);
      }
    },
    //metodo para obtenr la fecha de corte de programacion devsacacaiones:
    async obtenerFechaCorte() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta:"select case when now()::date between vp.fecha_corte and coalesce (vp.fecha_aprobacion,now()::date) then false else true end valor from vacaciones.v_programacion vp where vp.gestion =(select max(vp.gestion) from vacaciones.v_programacion vp)"){
                  respuesta
                  }
                }	
              `
        });
        if (respuesta.runQuery.respuesta.length > 0) {
          if (respuesta.runQuery.respuesta[0].valor == true) {
            this.bandera_fecha_corte = true;
            return;
          } else {
            this.bandera_fecha_corte = false;
            return;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    getIdPersona() {
      const user = this.$storage.get("user");
      let id_persona = user.id_persona;
      return id_persona;
    },
    // Metodo para listar la tabla
    async cargarVacacionesProgramadas(periodo) {
      try {
        this.lista_vacaciones = [];
        this.loading = true;
        let resp = await this.$service.graphql({
          query: `
            query{
                  runQuery(consulta:"select * FROM vacaciones.v_vac_programacion_reprogramacion_a_cuenta_vacacion vvp WHERE vvp.id_jefe=${parseInt(
                    this.user.id_persona
                  )} and vvp.gestion=${parseInt(
            periodo
          )} and (vvp.id_estado not in (22,51,73,66,54,67,68,69,71,9,47) or(vvp.id_estado=71 and vvp.tipo='FR')) order by fecha_actualizacion desc"){
                  respuesta
                  }
                }	
          `
        });
        let lista_tmp = resp.runQuery.respuesta;
        this.lista_vacaciones = lista_tmp;
        // Ordenamos la lista
        // Separamomos negativos y positivos
        // var lista_nega = [];
        // var lista_posi = [];
        // lista_tmp.forEach(element => {
        //   if (element.dias_faltantes < 0) {
        //     lista_nega.push(element);
        //   } else {
        //     lista_posi.push(element);
        //   }
        // });
        // // Ordenamos lista nega descendentemente
        // lista_nega.sort(function(a, b) {
        //   if (a.dias_faltantes < b.dias_faltantes) {
        //     return 1;
        //   }
        //   if (a.dias_faltantes > b.dias_faltantes) {
        //     return -1;
        //   }
        //   return 0;
        // });
        // // Ordenamos lista posi ascendentemente
        // lista_posi.sort(function(a, b) {
        //   if (a.dias_faltantes > b.dias_faltantes) {
        //     return 1;
        //   }
        //   if (a.dias_faltantes < b.dias_faltantes) {
        //     return -1;
        //   }
        //   return 0;
        // });
        // // unimos listas
        // this.lista_vacaciones = lista_posi.concat(lista_nega);
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    // <!-- ------------------------------------------------- FUNCONES VACACIONES PROGRAMADAS Y REPROGRAMADAS--------------------------------------------->
    solicitarEjecucionVacacion(item) {
      // item.funcionario = this.funcionario;
      // item.saldo = this.saldo;
      this.$bus.$emit("openDialogSolicitarEjecucionVacacion", item);
    },
    reprogramarCronograma(item) {
      if (true) {
        this.$bus.$emit("openDialogReprogramar", item);
      } else {
        this.$confirm("Ya realizó la reprogramación", () => {});
      }
    },
    verDetalle(item) {
      if (item.tipo == "P") {
        this.$bus.$emit("openDialogVerDetalleUsoVacacionRRHH", item);
      } else {
        this.$bus.$emit("openDialogVerDetalleUsoFuncionarioNormalRRHH", item);
      }
    },
    verReprogramaciones(item) {
      this.$bus.$emit("openDialogVerReprogramaciones", item);
    },
    aprobarUsoJefeInmediato(item) {
      this.$bus.$emit("openDialogAprobarUsoJefeInmediato", item);
    },
    aprobarReprogramacion(item) {
      this.$bus.$emit("openDialogAprobarReprogramacion", item);
    },
    reprogramar(item) {
      this.$bus.$emit("openDialogReprogramarJefeInmediato", item);
    },
    verReporte(item, valor) {
      item.reprogramacion = valor;
      this.$bus.$emit("openDialogVerReporte", item);
    },
    rechazarReprogramacion(item) {
      this.$bus.$emit("openDialogRechazarReprogramacionJefe", item);
    },
    // <!-- ------------------------------------------------- FUNCONES PAPELETAS CON CARGO A VACACION---------------------------------------------->
    aprobarPermiso(item) {
      item.nivel_jefe = 2;
      this.$bus.$emit("openDialogAprobarPermisoCtaVacacionJefeI", item);
    },

    rechazarPermiso(item) {
      this.$bus.$emit("openDialogRechazarPermisoCtaVacacionJefeI", item);
    },
    verPermiso(item) {
      this.$bus.$emit("openDialogVerPermisoRRHH", item);
    }
  },
  // Definición de componentes importados
  components: {
    CrudTable,
    ReprogramarCronograma,
    VerDetalle,
    SolicitarEjecucionVacacion,
    AprobarUsoJefeInmediato,
    Reprogramar,
    VerReporte,
    VerDetalleUsoVacacion,
    AprobarReprogramacionVacacion,
    VerReprogramaciones,
    CalendarioVacaciones,
    AprobarPermiso,
    RechazarPermiso,
    VerPermiso,
    RechazarReprogramacionJefe
  }
};
</script>

<style lang="scss">
#celdaP {
  background: rgba(103, 236, 179, 0.3);
}
#celdaR {
  background: rgba(241, 217, 111, 0.3);
}
#celdaVC {
  background: rgba(189, 143, 238, 0.3);
}
#celdaFR {
  background: rgba(141, 208, 240, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_uso/VacacionUsoJefeInmediato.vue